import '~/jssrc/jquery_global';
import '~/jssrc/layout';
import 'bootstrap-sass';

import 'summernote';
import "chartkick/chart.js"
import 'pickadate/lib/picker.date';
import 'jquery-treegrid/js/jquery.treegrid.js';
import 'jquery-treegrid/js/jquery.treegrid.bootstrap3.js';

import '~/jssrc/multi_file_upload';
import '~/jssrc/bootstrap-slider';
import '~/jssrc/jqmodal';
import '~/jssrc/ui_element_hooks';
import '~/jssrc/skills';
import '~/jssrc/talents';
import '~/jssrc/candidates';
import '~/jssrc/resumes';
import '~/jssrc/base_ext';

import RailsUJS from '@rails/ujs';
RailsUJS.start();  //if (!window._rails_loaded)

import { Application } from "@hotwired/stimulus"
import { registerControllers } from "stimulus-vite-helpers";
const stimulus_app  = Application.start();  //stimulus_app.debug = true
const controllers = import.meta.glob("~/**/*_controller.js", {eager: true});
registerControllers(stimulus_app, controllers);
